import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '@/views/index.vue'
import Error from '@/views/Error.vue'
import PcView from '@/views/PcView.vue'
import ClientView from '@/views/ClientView.vue'
import News from '@/views/news'
import NewsDetail from '@/views/news/Detail.vue'
import PageDetail from '@/views/PageDetail.vue'

const routerPush = VueRouter.prototype.push
const routerReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => console.info('router error'))
}

VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => console.info('router error'))
}


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: index
  },
  {
    path: '/error',
    name: 'error',
    component: Error
  },
  {
    path: '/pcView',
    name: 'pcView',
    component: PcView
  },
  {
    path: '/clientView',
    name: 'clientView',
    component: ClientView
  },
  {
    path: '/newsView',
    name: 'newsView',
    component: News
  },
  {
    path: '/newsView/detail',
    name: 'newsDetail',
    component: NewsDetail
  },
  {
    path: '/pageDetail',
    name: 'pageDetail',
    component: PageDetail
  },
  {
    path: '/preview',
    name: 'preview',
    component: PageDetail
  }
]

const router = new VueRouter({
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js